module.exports = __webpack_public_path__ + "static/img/andarbahar_th.119c9af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sa/andarbahar_th.png
// module id = G5XN
// module chunks = 1